<template>
    <div class="container">
        <span>菜品销售明细</span>
        <div class="search-box">
            <el-form label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="结账时间">
                            <el-date-picker class="search-input" v-model="dateTime" type="daterange"
                                value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="菜品名称:">
                            <el-input class="search-input" v-model="queryInfo.condition.productName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="订单编号:">
                            <el-input class="search-input" v-model="queryInfo.condition.orderNumber"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="桌台名称:">
                            <el-input class="search-input" v-model="queryInfo.condition.tableName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="制作人名称:">
                            <el-input class="search-input" v-model="queryInfo.condition.producerName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="点单人名称:">
                            <el-input class="search-input" v-model="queryInfo.condition.orderUserName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="菜类名称:">
                            <el-input class="search-input" v-model="queryInfo.condition.categoryName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14" style="display: flex;justify-content: flex-end;">
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search"
                                style="background-color: #f59a23;border: none;" @click="search">查询</el-button>
                            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </div>
        <el-table lement-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.3)" v-loading="loading" :data="tableData"
            style="width: 100%;margin-top: 20px;" border>
            <el-table-column type="index" width="100" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="merchantName" label="商家名称" align="center" width="180"></el-table-column>
            <el-table-column prop="orderNumber" label="订单号" align="center" width="180"></el-table-column>
            <el-table-column prop="transNo" label="流水号" align="center" width="180"></el-table-column>
            <el-table-column prop="productName" label="菜品名称" align="center" width="180"></el-table-column>
            <el-table-column prop="categoryName" label="菜类名称" align="center" width="180"></el-table-column>
            <el-table-column prop="tableName" label="桌台名称" align="center" width="180"></el-table-column>
            <el-table-column prop="unit" label="单位" align="center" width="180"></el-table-column>
            <el-table-column prop="normalPrice" label="正常单价" align="center" width="180"></el-table-column>
            <el-table-column prop="productPrice" label="产品单价" align="center" width="180"></el-table-column>
            <el-table-column prop="num" label="数量" align="center" width="180"></el-table-column>
            <el-table-column prop="assiAmount" label="剩余数量" align="center" width="180"></el-table-column>
            <el-table-column prop="discountRate" label="折扣率" align="center" width="180"></el-table-column>
            <el-table-column prop="payPrice" label="支付价格" align="center" width="180"></el-table-column>
            <el-table-column prop="sumPrice" label="总价" align="center" width="180"></el-table-column>
            <el-table-column prop="producedDt" label="生产日期" align="center" width="180"></el-table-column>
            <el-table-column prop="producerName" label="制作人名称" align="center" width="180"></el-table-column>
            <el-table-column prop="isProduced" label="是否已制作" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isProduced == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>

            <el-table-column prop="makeDepart" label="制作部门" align="center" width="180"></el-table-column>
            <el-table-column prop="makeCostPrice" label="制作成本" align="center" width="180"></el-table-column>
            <el-table-column prop="presentUserName" label="赠送人员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="isPay" label="是否已支付" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isPay == 1">已支付</span>
                    <span v-else>未支付</span>
                </template>
            </el-table-column>
            <el-table-column prop="isSend" label="是否已发送" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isSend == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="sendTime" label="发送时间" align="center" width="180"></el-table-column>
            <el-table-column prop="orderTime" label="结账时间" align="center" width="180"></el-table-column>
            <el-table-column prop="orderUserName" label="点单人员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="isAdd" label="是否加菜" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isAdd == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="isWeighSell" label="是否是称重商品" align="center" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.isWeighSell == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="businessDate" label="营业日期" align="center" width="180"></el-table-column>
            <el-table-column prop="salesManName" label="销售人员名称" align="center" width="180"></el-table-column>
            <el-table-column prop="taxSum" label="税额" align="center" width="180"></el-table-column>
            <el-table-column prop="costAvgPrice" label="成本均价" align="center" width="180"></el-table-column>
            <el-table-column prop="costSum" label="成本金额" align="center" width="180"></el-table-column>
            <el-table-column prop="grossProfit" label="毛利" align="center" width="180"></el-table-column>
            <el-table-column prop="grossProfitRate" label="毛利率" align="center" width="180"></el-table-column>
            <el-table-column prop="groupName" label="连锁名称" align="center" width="180"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center" width="180"></el-table-column>
            <el-table-column prop="returnNum" label="退货数量" align="center" width="180"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.currPage" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();
let currentDate2 = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
currentDate2.setDate(currentDay - 1);
export default {
    name: '',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            type: 1,
            dateTime: [currentDate2, currentDate],
            queryInfo: {
                condition: {
                },
                currPage: 1,
                pageCount: 1,
                pageSize: 10,
            },
            tableData: [],
            loading: false,
            total: 0,
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        search() {
            this.getData();
        },
        reset() {
            this.queryInfo = {
                condition: {
                },
                currPage: 1,
                pageCount: 1,
                pageSize: 10,
            }
            this.dateTime = [currentDate2, currentDate]
            this.getData();
        },
        // 获取当前页面
        handleCurrentChange(val) {
            this.queryInfo.currPage = val;
            this.getData();
        },
        // 修改页数大小
        handleSizeChange(val) {
            this.queryInfo.pageSize = val;
            this.getData();
        },
        async getData() {

            if (this.dateTime && this.dateTime.length > 0) {
                this.queryInfo.condition.startTime = moment(this.dateTime[0]).format('YYYY-MM-DD') + ' 00:00:00'
                this.queryInfo.condition.endTime = moment(this.dateTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
            }


            this.queryInfo.condition.merchantCode = localStorage.getItem('merchantCode')
            this.loading = true
            let res = await this.$http.post('/merchantOrderItemHistory/saleDetails', this.queryInfo)
            if (res.data.code == 200) {
                this.total = res.data.data.count;
                this.queryInfo.currPage = res.data.data.currPage;
                this.tableData = res.data.data.data;
                this.loading = false
            } else {
                this.loading = false
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 20px;
}

.search-box {
    width: 100%;
    margin-top: 20px;

    .search-input {
        width: 100%;
    }
}
</style>